import { Target, Heart, Zap, ShieldCheck } from "lucide-react";
import { PublicPage, PageHero, Seo } from "@/components/public/PublicChrome";

const VALUES = [
  { icon: Target, title: "Founder-first", desc: "Every decision starts with what actually helps entrepreneurs move forward." },
  { icon: Zap, title: "Clarity over complexity", desc: "We turn confusing business processes into simple, guided next steps." },
  { icon: ShieldCheck, title: "Trust & security", desc: "Your data and documents are protected with bank-grade security." },
  { icon: Heart, title: "In your corner", desc: "From formation to funding, we're the partner that grows with you." },
];

const STATS = [["10", "Integrated modules"], ["7-day", "Free trial, no card"], ["24/7", "AI advisor access"], ["100%", "Your data, preserved"]];

export default function About() {
  return (
    <PublicPage>
      <Seo title="About" path="/about" description="Fairview Systems exists to give every entrepreneur an all-in-one command center to launch, fund, and grow their business with confidence." />
      <PageHero eyebrow="About" title="We help founders build with confidence"
        subtitle="Fairview Systems was built on a simple belief: starting and growing a business should not require juggling ten disconnected tools." />
      <section className="py-16 px-6">
        <div className="max-w-4xl mx-auto space-y-6 text-[#D4D4D8] leading-relaxed">
          <p>Most entrepreneurs lose momentum not from a lack of ambition, but from a lack of clarity — unsure which step comes next, which vendor reports to credit bureaus, or what lenders actually want to see. Fairview Systems brings formation, business credit, funding, contracts, education, and an AI advisor into a single, premium command center.</p>
          <p>Our platform meets you where you are and shows you exactly what to do next, personalized to your progress. Whether you're forming your first LLC or scaling an established company, Fairview grows with you — and your data, documents, and progress are always yours to keep.</p>
        </div>
        <div className="max-w-5xl mx-auto grid grid-cols-2 lg:grid-cols-4 gap-4 mt-14">
          {STATS.map(([v, l]) => (
            <div key={l} className="rounded-2xl border border-white/8 bg-[#121214] p-6 text-center">
              <div className="font-heading text-3xl fv-gold-text">{v}</div>
              <div className="text-xs text-[#71717A] mt-1">{l}</div>
            </div>
          ))}
        </div>
      </section>
      <section className="py-16 px-6 border-t border-white/8">
        <div className="max-w-6xl mx-auto">
          <h2 className="font-heading text-3xl mb-10 text-center">What we value</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {VALUES.map((v) => (
              <div key={v.title} className="rounded-2xl border border-white/8 bg-[#121214] p-6">
                <div className="w-11 h-11 rounded-xl bg-[#D4AF37]/10 border border-[#D4AF37]/20 flex items-center justify-center mb-4"><v.icon className="w-5 h-5 text-[#D4AF37]" /></div>
                <h3 className="font-heading text-lg mb-2">{v.title}</h3>
                <p className="text-sm text-[#A1A1AA] leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </PublicPage>
  );
}
